/**
 * Shown when a Microsoft-broker login succeeds at Keycloak but Jupiter finds
 * no tenant_domain row for the user's email domain (see
 * jupiter/dependencies.py -- TENANT_NOT_LICENSED). No account is
 * auto-provisioned in this case; the user must contact their IT department to
 * get onboarded by Lytra.
 */
export default function TenantNotLicensedScreen({
  onSignOut,
}: {
  onSignOut: () => void;
}) {
  return (
    <div
      className="flex h-screen w-screen items-center justify-center"
      style={{ backgroundColor: "#D1F2FA" }}
    >
      <div
        className="w-full max-w-md rounded-[34px] bg-white p-10 text-center shadow-xl"
        style={{ fontFamily: "'Sora', system-ui, sans-serif" }}
      >
        <h1 className="mb-3 text-xl font-semibold" style={{ color: "#07195F" }}>
          Noch nicht freigeschaltet
        </h1>
        <p
          className="mb-8 text-sm"
          style={{ color: "#39477F", fontFamily: "'Inter', system-ui, sans-serif" }}
        >
          Sie sind noch nicht freigeschaltet. Bitte wenden Sie sich an Ihre
          IT-Abteilung.
        </p>
        <button
          type="button"
          onClick={onSignOut}
          className="rounded-xl px-4 py-2 text-sm font-semibold text-white transition-opacity hover:opacity-90"
          style={{ backgroundColor: "#345AEF" }}
        >
          Zurück zur Anmeldung
        </button>
      </div>
    </div>
  );
}
